module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"layerGroupInfo-title":"Information sur la carte","legend-title":"Légende"},"de":{}}')
  delete Component.options._Ctor
}
